window.cart = { size: 0 }
window.tokenKey = 'cortinasToken'
window.token = localStorage.getItem(window.tokenKey)
window.swal = require('sweetalert2')
window.userKey = 'cortinasSessionUser'
window.currentUser = JSON.parse(localStorage.getItem(window.userKey))

window.logout = () => {
  localStorage.setItem(window.userKey, null);
  localStorage.setItem(window.tokenKey, null);
  location.reload();
}

window.refreshUser = callback => {
  if (window.token) {
    window.api.get('user/details', window.token).then(data => {
      window.currentUser = data;
      localStorage.setItem(window.userKey, JSON.stringify(data));
      if (callback) callback();
    });
  } else {
    if (callback) callback();
  }
}

window.loader = () => {
  document.querySelector('#app').style.opacity = 0;
  setTimeout(function() {
    let opacity = 0;
    var i = setInterval(function() {
      document.querySelector('#app').style.opacity = opacity;
      if (parseInt(opacity) === 1) {
        return window.clearInterval(i);
      }
      opacity = opacity + .01;
    }, 1);
  }, 500);
};

window.unsecureOnly = (to, from, next) => {
  if (window.currentUser && window.currentUser.entity_id) return window.location = '/';
  next();
}

window.secureOnly = (to, from, next) => {
  if (!(window.currentUser && window.currentUser.entity_id)) return window.location = '/';
  next();
}

window.isTestEnv = () => {
  return window.location.host.indexOf('localhost') >= 0
}

window.getScript = function (source, callback) {
  var script = document.createElement('script');
  var prior = document.getElementsByTagName('script')[0];
  script.async = 1;

  script.onload = script.onreadystatechange = function( _, isAbort ) {
    if(isAbort || !script.readyState || /loaded|complete/.test(script.readyState) ) {
      script.onload = script.onreadystatechange = null;
      script = undefined;

      if(!isAbort) { if(callback) callback(); }
    }
  };

  script.src = source;
  prior.parentNode.insertBefore(script, prior);
};



//////////////////
// WEBPACK FOOTER
// ./helpers/utils.js
// module id = 6QRH
// module chunks = 15